var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"bottom-banner m-btn",attrs:{"href":"https://schooluniversity.ru/web-psychologies?utm_source=SiteBanner&utm_medium=site&utm_campaign={campaign_id}&utm_term=баннер_главная&marketer=dvk&produkt=67018269&utm_gen=3 ","target":"_blank"}})
}
var staticRenderFns = []

export { render, staticRenderFns }